<app-title-bar
  *ngIf="!isScoped"
  title="Employee Update Audit Log"
  description="Add / edit / remove activity for admins, attendants, and staff across all companies."
>
</app-title-bar>

<div class="audit-log-toolbar">
  <input
    class="form-control audit-log-search"
    type="search"
    placeholder="Search by name or email…"
    [ngModel]="searchTerm"
    (ngModelChange)="onSearchInput($event)"
  />
  <select
    *ngIf="!isScoped"
    class="form-control audit-log-company"
    [(ngModel)]="companyFilterId"
    (ngModelChange)="onFilterChange()"
    aria-label="Filter by company"
  >
    <option value="">All companies</option>
    <option *ngFor="let company of companyOptions" [value]="company.id">{{ company.name }}</option>
  </select>
  <select class="form-control" [(ngModel)]="targetType" (ngModelChange)="onFilterChange()">
    <option value="">All roles</option>
    <option *ngFor="let type of targetTypeOptions" [value]="type">{{ type }}</option>
  </select>
  <select class="form-control" [(ngModel)]="action" (ngModelChange)="onFilterChange()">
    <option value="">All actions</option>
    <option *ngFor="let a of actionOptions" [value]="a">{{ a }}</option>
  </select>
  <input
    class="form-control"
    type="date"
    [(ngModel)]="dateFrom"
    (ngModelChange)="onFilterChange()"
  />
  <input class="form-control" type="date" [(ngModel)]="dateTo" (ngModelChange)="onFilterChange()" />
  <button
    type="button"
    class="btn btn-outlined btn-medium"
    (click)="loadEntries()"
    [disabled]="loading"
  >
    Refresh
  </button>
</div>

<div class="audit-log-state" *ngIf="loading">Loading audit log…</div>
<div class="audit-log-state audit-log-state--error" *ngIf="!loading && errorMessage">
  {{ errorMessage }}
</div>
<div class="audit-log-state" *ngIf="!loading && !errorMessage && entries.length === 0">
  No audit events found.
</div>

<div class="audit-log-table-wrap" *ngIf="!loading && entries.length > 0">
  <table class="audit-log-table">
    <thead>
      <tr>
        <th>Timestamp</th>
        <th *ngIf="!isScoped">Company</th>
        <th>Action</th>
        <th>Target</th>
        <th>Performed by</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let entry of entries">
        <tr>
          <td>{{ formatCreatedAt(entry.created_at) }}</td>
          <td *ngIf="!isScoped">{{ entry.company_name || '—' }}</td>
          <td>
            <span class="audit-log-pill" [class]="'audit-log-pill--' + entry.action">
              {{ entry.action }}
            </span>
          </td>
          <td>
            <div class="audit-log-target">
              <span class="audit-log-target__role">{{ entry.target_type }}</span>
              <span>{{ entry.target_name || entry.target_email || '—' }}</span>
            </div>
          </td>
          <td>{{ entry.performed_by_name || entry.performed_by_email || '—' }}</td>
          <td>
            <button
              type="button"
              class="btn btn-outlined btn-small"
              (click)="toggleExpanded(entry)"
            >
              {{ expandedRowId === entry.id ? 'Hide' : 'Details' }}
            </button>
          </td>
        </tr>
        <tr *ngIf="expandedRowId === entry.id" class="audit-log-details-row">
          <td [attr.colspan]="isScoped ? 5 : 6">
            <pre class="audit-log-payload">{{ entry.payload | json }}</pre>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</div>

<app-pagination-bar
  *ngIf="totalItems > 0"
  [paginationData]="paginationData"
  (pageChange)="onPageChange($event)"
  (itemsPerPageChange)="onItemsPerPageChange($event)"
>
</app-pagination-bar>
